import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWallUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-wall-up, align top"} maskId="square-filled-radius-0-stroke-1-IconArrowWallUp"><path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V3H4V2ZM12 5.79289L17.4571 11.25L16.75 11.9571L12.5 7.70711V22H11.5V7.7071L7.25 11.9571L6.54289 11.25L12 5.79289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowWallUp;
